<script>
document.documentElement.style.fontSize = (document.documentElement.clientHeight / 720) * 10 + 'px'
export default {

  data () {
    return {
      url: this.$route.query.url
    }
  },
  mounted () {
    this.$watch(
      () => this.$route.params,
      () => {
        this.url = this.$route.query.url
      },
      { immediate: true }
    )
    window.addEventListener('message', (event) => {
      console.log(event.data)
      try {
        if (event.data === 'closePage') {
          if (window.webkit && window.webkit.messageHandlers) {
            this.$router.push('/main/earn_cash/0')
          } else {
            this.$router.go(-1)
          }
        } else {
          const data = JSON.parse(event.data)
          if (data.action === 'H5_routeWeb') {
            this.$router.push({
              path: '/landweb',
              query: { url: data.url },
              param: { url: data.url }
            })
          }
        }
      } catch (e) {
        console.log(e)
      }
    })
  }
}
</script>

<template>
  <iframe class="web" :src="url"></iframe>
</template>

<style scoped>
::-webkit-scrollbar {
  display: none;
}

.web {
  width: 104.8rem;
  height: 100%;
  border: none;
}
</style>
